import { HubConnection } from '@microsoft/signalr';
import BaseComponent from "@/asdcom/BaseComponent";
import util from '@/lib/util';
import AbpBase from '@/lib/abpbase';

export class StaffSignalrService extends BaseComponent {

    staffHub: HubConnection;
    isChatConnected = false;

    configureConnection(connection: any): void {
        // Set the common hub
        this.staffHub = connection;

        // Reconnect loop
        let reconnectTime = 5000;
        let tries = 1;
        let maxTries = 8;
        function start() {
            return new Promise(function (resolve, reject) {
                if (tries > maxTries) {
                    reject();
                } else {
                    connection.start()
                        .then(resolve)
                        .then(() => {
                            reconnectTime = 5000;
                            tries = 1;
                        })
                        .catch(() => {
                            setTimeout(() => {
                                start().then(resolve);
                            }, reconnectTime);
                            reconnectTime *= 2;
                            tries += 1;
                        });
                }
            });
        }

        // Reconnect if hub disconnects
        connection.onclose((e: any) => {
            this.isChatConnected = false;

            if (e) {
                abp.log.debug('Chat connection closed with error: ' + e);
            } else {
                abp.log.debug('Chat disconnected');
            }

            start().then(() => {
                this.isChatConnected = true;
            });
        });

        // Register to get notifications
        this.registerEvents(connection);

    }

    registerClient():void{
        this.staffHub.invoke("register");
    }

    registerEvents(connection: any): void {
        abp.log.debug({'staff-signalr.service.ts retisterEvents':connection});
        connection.on('getDashboardUpdate', (message: any) => {
            abp.log.debug({'staff-signalr.service.ts on StaffDashboardUpdate':message});
            abp.event.trigger('dashboard.update.received', message);
        });

        // connection.on('getAllFriends', friends => {
        //     abp.event.trigger('abp.chat.friendListChanged', friends);
        // });

        // connection.on('getFriendshipRequest', (friendData, isOwnRequest) => {
        //     abp.event.trigger('app.chat.friendshipRequestReceived', friendData, isOwnRequest);
        // });

        // connection.on('getUserConnectNotification', (friend, isConnected) => {
        //     abp.event.trigger('app.chat.userConnectionStateChanged',
        //         {
        //             friend: friend,
        //             isConnected: isConnected
        //         });
        // });

        // connection.on('getUserStateChange', (friend, state) => {
        //     abp.event.trigger('app.chat.userStateChanged',
        //         {
        //             friend: friend,
        //             state: state
        //         });
        // });

        // connection.on('getallUnreadMessagesOfUserRead', friend => {
        //     abp.event.trigger('app.chat.allUnreadMessagesOfUserRead',
        //         {
        //             friend: friend
        //         });
        // });

        // connection.on('getReadStateChange', friend => {
        //     abp.event.trigger('app.chat.readStateChange',
        //         {
        //             friend: friend
        //         });
        // });
    }

    SendDashboardUpdate(callback?:any):void{
        this.staffHub.invoke("sendDashboardUpdate","hi from client.").then(res=>{
            abp.log.debug({"staff-signalr.service.ts invoke res":res});
            if(callback){
                callback();
            }
        })
    }

    // sendMessage(messageData: any, callback: any): void {
    //     if (!this.isChatConnected) {
    //         if (callback) {
    //             callback();
    //         }

    //         abp.notify.warn(this.L('ChatIsNotConnectedWarning'));
    //         return;
    //     }

    //     this.staffHub.invoke('sendMessage', messageData).then(result => {
    //         if (result) {
    //             abp.notify.warn(result);
    //         }

    //         if (callback) {
    //             callback();
    //         }
    //     }).catch(error => {
    //         abp.log.error(error);

    //         if (callback) {
    //             callback();
    //         }
    //     });
    // }

    init(): void {
        // abp.log.debug({"staff-signalr.service init abp.signalr":util.abp.signalr});
        util.abp.signalr.connect();
        // util.abp.signalr.startConnection(abp.appPath + 'signalr-staff', (connection: any) => {
        util.abp.signalr.startConnection(asdcom.config.hostUrl + '/signalr-staff', (connection: any) => {
            // abp.log.debug({"staff-signalr.service connection":connection});
            this.configureConnection(connection);
        }).then(() => {
            // abp.log.debug({"staff-signalr.service.ts ":"connected"});
            abp.event.trigger('dashboard.connected');
            this.isChatConnected = true;
        });
    }
}
